import { Content } from '../../types';

export const kohKretContent: Content = {
  title: 'Koh Kret - האי הנסתר של נונתאבורי',
  imageUrl: '/images/thailand/koh-kret/koh-kret-wide.jpg',
  introduction:
    'Ko Kret, הינו אי קטן ומיוחד בלב נהר הצ\'או פראייה, הממוקם במחוז נונתאבורי (Nonthaburi), צפונית לבנגקוק.\nהאי נוצר בשנת 1722, כאשר נחפרה תעלה ע"מ לקצר את נתיב השייט לאיוטאיה, ששימשה אז כבירת ממלכת סיאם. מאז, נותר האי מבודד יחסית והפך לאחד המקומות האותנטיים והייחודיים ביותר באזור בנגקוק.\nהאי מפורסם בזכות קהילת בני שבט ה - מון (Mon), אחת הקבוצות האתניות העתיקות בתאילנד. בני המון ידועים באומנות כלי החרס המסורתיים שלהם, במקדשים ייחודיים ובאורח חייהם הכפרי, השונה מההמולה העירונית של בנגקוק.',
  sections: [
    {
      title: 'דרכי הגעה ל-Koh Kret',
      type: 'sub-headers',
      description: 'ישנן מספר דרכים נוחות להגיע לאי:',
      content: [
        {
          subtitle: 'ברכב',
          text: 'ניתן להגיע ברכב ישירות למקדש Wat Sanam Nuea, הממוקם ב Pak Kret, שם נמצא הרציף המרכזי שממנו יוצאות מעבורות לאי.',
        },
        {
          subtitle: 'באוטובוס',
          text: 'קו 166 יוצא מVictory Monument בבנגקוק ומגיע לשוק Pak Kret ומשם, הליכה בת מספר דקות למקדש Wat Sanam Nuea, שבו נמצא הרציף למעבורת.',
        },
        {
          subtitle: 'מעבורת',
          text: 'ברציף, עולים על מעבורת, החוצה את הנהר תוך דקה אחת בלבד ובעלות סמלית 5 באט לכיוון. המעבר פשוט, נוח ומהיר!',
        },
        {
          subtitle: 'ספינת שייט ציבורית',
          text: "אפשרות הגעה נוספת, הינה באמצעות ספינת שייט ציבוריות בנהר הצ'או פראייה, העוצר בסמוך ל-Ko Kret כחלק ממסלולה.",
        },
      ],
    },
    {
      title: 'איך לטייל באי?',
      type: 'sub-headers',
      description: 'ישנן שתי דרכים מרכזיות לחקור את האי:',
      content: [
        {
          subtitle: 'באופניים',
          text: 'הדרך הטובה ביותר לחוות את האי, הינה באמצעות אופניים, אותן ניתן לשכור בסמוך לרציף.\n<br />✔ עלות ההשכרה: 40-100 באט ליום.\n<br />✔ האי קטן יחסית - ניתן להקיף אותו תוך כשעה של רכיבה נינוחה.\n<br />✔ השבילים שקטים, מוקפים בטבע ומאפשרים גישה קלה לכל הפינות היפות של האי.',
        },
        {
          subtitle: 'רגלית',
          text: 'במידה ותעדיפו קצב רגוע יותר, ניתן לטייל רגלית בין הכפרים, לבקר במקדשים וליהנות משווקי האוכל המקומיים.',
        },
      ],
    },
    {
      title: 'אטרקציות ב-Ko Kret',
      type: 'sub-headers',
      description: 'האי מציע מגוון אטרקציות ייחודיות:',
      content: [
        {
          subtitle: 'מקדש Wat Poramai Yikawat',
          text: 'המקדש המרכזי והידוע ביותר באי. הסמל הבולט ביותר שלו הוא הסטופה (Chedi) הלבנה והנטויה על צידה, השוכנת ממש על גדת הנהר - אחד האייקונים המזוהים ביותר עם האי.',
        },
        {
          subtitle: 'שוק סוף השבוע של Ko Kret',
          text: 'מתקיים בשבת וראשון והינו מקום נהדר לחוות את התרבות המקומית:<br />✔ דוכני אוכל מסורתי, כולל מנות ייחודיות של בני שבט ה - Mon.<br />✔ דוכנים למכירת כלי חרס בעבודת יד - סימן ההיכר של האי.<br />✔ מופעי תרבות מקומיים ואווירה אותנטית במיוחד.',
        },
        {
          subtitle: 'כפר Ban Mon ומפעלי כלי החרס',
          text: 'אחד מסימני ההיכר של האי, הינו תעשיית כלי החרס המסורתיים של בני שבט ה - Mon. ניתן לצפות בתהליך הייצור, להתנסות ביצירת כלי חרס משלכם ואפילו לרכוש מזכרות בעבודת יד.',
        },
        {
          subtitle: 'פינות טבע ורוגע',
          text: 'מסלולי ההליכה והרכיבה על האי עוברים בין כפרים מסורתיים, גשרים קטנים מעל תעלות מים ונקודות תצפית יפהפיות על הנהר. זוהי חוויה כפרית יוצאת דופן, ממש ליד בנגקוק.',
        },
      ],
    },
    {
      title: 'דוכן בקו קרט',
      type: 'image',
      imageUrl: '/images/thailand/koh-kret/koh-kret-article-1.jpg',
      content: '',
    },
    {
      title: 'מדוע לבקר ב-Ko Kret?',
      type: 'sub-headers',
      description: 'הנה כמה סיבות משכנעות לביקור באי:',
      content: [
        {
          subtitle: 'חוויה אותנטית ומסורתית',
          text: 'הצצה לחיי בני שבט ה - Mon ולתרבותם הייחודית.',
        },
        {
          subtitle: 'טבע וירוק בעיניים',
          text: 'האי מציע אווירה כפרית ורוגע בלב הנהר.',
        },
        {
          subtitle: 'מתאים לכל הגילאים',
          text: 'אפשר ליהנות מטיול רגלי, רכיבה על אופניים, אוכל מקומי ושווקים אותנטיים.',
        },
        {
          subtitle: 'נגיש וקל להגעה',
          text: 'נמצא במרחק קצר מבנגקוק ומציע חוויית בריחה מההמולה העירונית.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      content:
        'במידה והינכם מחפשים יעד שקט, יפה, אותנטי ויוצא דופן מהאורבניות של בנגקוק - Ko Kret הינו המקום המושלם עבור טיול יום מחוץ לבנגקוק!',
      type: 'text',
      isBold: true,
    },
  ],
};
